import { render } from "./CTABox.vue?vue&type=template&id=dffa38c4"
import script from "./CTABox.vue?vue&type=script&lang=js"
export * from "./CTABox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__